module.exports = __webpack_public_path__ + "img/199.problem_broken_door.de43bbeb.svg";